/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import 'react-day-picker/lib/style.css';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import {
  Button, IconButton, Grid,
} from '@material-ui/core';

import { Field } from 'redux-form';
import googleStorageServices from '../../../../redux/services/googleStorageServices';

const renderField = ({
  input, label, type, meta: { touched, error },
}) => (
  <div>
    <label>{label}</label>
    <input {...input} type={type} placeholder={label} style={{ width: '100%' }} />
    {touched && error && <span>{error}</span>}
  </div>
);

const getOptions = (query, callback) => {
  googleStorageServices.getResources()
    .then((res) => {
      const tmp = [];
      res.data[0].forEach((data) => {
        const tmpName = data.name.replace('resources/pdf/', '');
        if (tmpName.length > 1 && !tmpName.includes(' ')) {
          tmp.push({ label: tmpName, value: tmpName });
        }
      });
      callback(tmp);
    });
};

const renderAsyncSelectField = ({
  input,
  label,
  ...custom
}) => (
  <AsyncSelect
    {...input}
    {...custom}
    cacheOptions
    styles={{ width: '100%' }}
    onChange={(value) => input.onChange(value)}
    defaultOptions
    loadOptions={(query, callback) => getOptions(query, callback)}
    classNamePrefix="react-Selector"
    onBlur={() => input.onBlur(input.value)}
  />
);

const FieldProgEval = ({
  fields, children, tabval,
}) => (
  <ul>
    {fields.map((member, index) => (
      <div style={{ backgroundColor: '#EFEFEF', padding: ' 5px' }} key={tabval}>
        <Grid container direction="row">
          <Grid item md={1}>
            <div>
              <IconButton
                aria-label="delete"
                color="secondary"
                title="Remove Block"
                onClick={() => fields.remove(index)}
              >
                <DeleteIcon fontSize="large" />

              </IconButton>
            </div>
          </Grid>
          <Grid item md={11}>
            <h4>{fields.get(index).title ? fields.get(index).title : ''}</h4>
            <h5>{fields.get(index).filename ? fields.get(index).filename : ''}</h5>
          </Grid>
        </Grid>
      </div>
    ))}
    <h5 style={{ marginTop: '10px' }}>
      Title
    </h5>
    <Field
      name={`title${tabval}`}
      type="text"
      placeholder="Titre"
      component={renderField}
    />
    <h5 style={{ marginTop: '10px' }}>
      File name
    </h5>
    <Field
      name={`filename${tabval}`}
      component={renderAsyncSelectField}
      type="selectCourse"
      label="Course"
    />
    <Grid container direction="row" style={{ marginTop: '20px' }}>
      <Grid item md={3}>
        <Button
          variant="contained"
          name={`add ${tabval}`}
          color="primary"
          type="button"
          onClick={() => {
            fields.push({
              title: (children.values[`title${tabval}`] ? children.values[`title${tabval}`] : ''),
              filename: (children.values[`filename${tabval}`] && children.values[`filename${tabval}`].value ? children.values[`filename${tabval}`].value : ''),
            });
          }}
        >
          Add Block
        </Button>
      </Grid>
      <Grid md={3}>
        <Button
          variant="contained"
          name={`clear ${tabval}`}
          color="secondary"
          type="button"
          onClick={() => {
            fields.removeAll();
          }}
        >
          Clear Values
        </Button>
      </Grid>
    </Grid>
  </ul>
);

FieldProgEval.propTypes = {
  fields: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  tabval: PropTypes.any.isRequired,
};

export default FieldProgEval;
